<template>
  <div class="login-box">
    <div class="home-login">
      <div
        class="home-login-left"
        :style="lefMenuThemeStyle">
        <img
          class="logo-bg"
          :src="getLogoBgByTheme()"
          alt="" />
        <img
          v-if="isLogoVisible && isLightTheme()"
          src="@/assets/logo/login_title.png"
          class="home-login-left-right"
          alt="" />
      </div>
      <div
        class="home-login-right"
        :style="rightMenuThemeStyle">
        <div
          class="login-panel"
          :style="loginPanelThemeStyle">
          <div>
            <div class="login-title">
              <span class="login-title-wel">欢迎登录</span>
              <!-- <span class="login-title-tex">国产自主三维图形引擎</span> -->
            </div>
          </div>
          <!-- 账号登录 -->
          <el-form
            :model="loginForm"
            class="form"
            ref="loginForm"
            :rules="rules">
            <el-form-item prop="userNameOrPhone">
              <el-input
                class="input-primary"
                @focus="onFocus('loginForm', 'userNameOrPhone')"
                placeholder="请输入手机号/用户名"
                prefix-icon="el-icon-user"
                v-model="loginForm.userNameOrPhone">
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                class="input-primary"
                @focus="onFocus('loginForm', 'password')"
                placeholder="请输入密码"
                show-password
                prefix-icon="el-icon-lock"
                v-model="loginForm.password">
              </el-input>
            </el-form-item>
            <el-form-item class="last-form">
              <el-button
                class="primary-btn primary-angb-btn login-btn"
                size="small"
                type="primary"
                @click="login">
                登录
              </el-button>
            </el-form-item>
          </el-form>
          <div
            class="img-box"
            v-if="imgVisible">
            <img
              class="back-img"
              :src="verificatePictureInfo.BackgroundImg"
              alt="" />
            <img
              class="slider-img"
              :style="`top:${verificatePictureInfo.PositionY}px;left:${verificatePictureInfo.PositionX}px`"
              :src="verificatePictureInfo.SlideImg"
              alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { passwordRules, phoneRules } from '@/utils/formValidateRules'
import { encryptPassword } from '@/utils/generalMethods'

import {
  loginService,
  sendValidateNoService,
  getVerificatePicture
} from '@/service/interface'

export default {
  data() {
    const validPhoneNo = (rule, value, callback) => {
      let reg = /^[1][2-9][0-9]{9}$/
      if (reg.test(value)) {
        this.loginForm.btnDisable = false
        callback()
      } else {
        this.loginForm.btnDisable = true
        let reg2 = /^[1][2-9][0-9]{1}$/
        if (value.length > 2 && !reg2.test(value.substr(0, 3))) {
          return callback(new Error('请输入合法的手机号码'))
        }
      }
    }
    return {
      isLogoVisible: window.isLogoVisible,
      isPrivate: window.isPrivate,
      // notifyVisible: true,

      isTwoFactorLogin: window.isTwoFactorLogin,
      isPictureValid: window.isPictureValid,
      loginForm: {
        userNameOrPhone: '',
        phone: '',
        validateNo: '',
        password: '',
        rememberMe: false,
        btnName: '发送验证码',
        btnDisable: true
      },
      imgVisible: false,
      verificatePictureCode: '',
      verificatePictureInfo: {},
      indicatorWidth: 0,
      sliderStatus: '',
      indicatorStatus: '',
      tipsText: '向右拖动滑块填充拼图',
      indicatorSuccess: false,
      rules: {
        userNameOrPhone: [
          { required: true, message: '请输入手机号/用户名', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9_\u4e00-\u9fa5]{2,20}$|^[1][2-9][0-9]{9}$/,
            message: '手机号码或2-20位字符, 仅可含汉字、字母、数字、下划线',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
          },
          {
            pattern: phoneRules.pattern,
            message: phoneRules.message,
            trigger: 'blur'
          },
          { validator: validPhoneNo }
        ],
        validateNo: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            pattern: /^[0-9]{6}$/,
            message: '请输入正确的验证码',
            trigger: 'blur'
          }
        ]
      },

      lefMenuThemeStyle: {},
      rightMenuThemeStyle: {},
      loginPanelThemeStyle: {}
    }
  },
  mounted() {
    const themeType = this.$theme.get().value
    if (themeType === 'stellar-light') {
      this.lefMenuThemeStyle = {
        width: 'calc(100% - 680px)'
      }
      this.rightMenuThemeStyle = {
        width: '680px',
        position: 'relative'
      }
      this.loginPanelThemeStyle = { right: ' 112px' }
    } else if (themeType === 'dark') {
      this.lefMenuThemeStyle = {
        width: '100%'
      }
      this.rightMenuThemeStyle = {
        width: '0',
        position: 'absolute',
        top: '0',
        left: '50%'
      }
      this.loginPanelThemeStyle = { right: 'unset' }
    }

    let loginFlag = sessionStorage.getItem('loginFlag')
    if (!(loginFlag && loginFlag !== 'false')) return
    if (document.cookie.length > 0 && !loginFlag) {
      this.login()
    }
  },
  methods: {
    login() {
      // this.$message.error("服务升级中");

      let validateFailFlag = false
      this.$refs.loginForm.validateField(
        ['userNameOrPhone', 'password'],
        error => {
          if (error) {
            validateFailFlag = true
            this.$message.error(error)
          }
        }
      )
      if (validateFailFlag) return
      this.loginByPassword()
    },
    loginByPassword() {
      let params = {
        userNameOrPhone: this.loginForm.userNameOrPhone,
        password: encryptPassword(this.loginForm.password),
        rememberMe: this.loginForm.rememberMe
      }
      if (window.isTwoFactorLogin) {
        params.phone = this.loginForm.phone
        params.verificationCode = this.loginForm.validateNo
      }
      loginService(params).then(response => {
        if (response.status === 200) {
          let data = response.data
          if (data.isSuccess) {
            this.$message.success('登录成功')
            sessionStorage.setItem('token', data.token)
            sessionStorage.setItem('tokenId', data.tokenId)
            sessionStorage.setItem('recentLogin', new Date().getTime())
            sessionStorage.setItem('loginFlag', true)
            this.$router.push('./projectList')
          } else {
            let errMsg = data.errMsg
            this.$message.error(errMsg)
          }
        }
      })
    },
    sendValidateNo(formType, validateType) {
      let validateFailFlag = false
      this.$refs[formType].validateField('phone', error => {
        if (error) {
          this.$message.error(error)
          validateFailFlag = true
        }
      })
      if (validateFailFlag) return
      let params = {
        phone: this[formType].phone,
        validateType: validateType,
        userNameOrPhone: this[formType].userNameOrPhone
      }
      let startTime = new Date().getTime()
      this[formType].btnDisable = true
      this[formType].btnName = `60s后重试`
      this.timer = setInterval(() => {
        let currentTime = new Date().getTime()
        let deltaTime = parseInt((currentTime - startTime) / 1000)
        if (deltaTime >= 60) {
          clearInterval(this.timer)
          this.timer = null
          this[formType].btnDisable = false
          this[formType].btnName = '发送验证码'
        } else {
          this[formType].btnName = `${60 - deltaTime}s后重试`
        }
      }, 1000)
      sendValidateNoService(params).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            this.$message.success('验证码发送成功')
          } else {
            this.$message.error(data.errMsg)

            clearInterval(this.timer)
            this.timer = null
            this[formType].btnDisable = false
            this[formType].btnName = '发送验证码'

            this[formType].phone = ''
            this[formType].validateNo = ''
            this.active = 'register'
            this.registerStep = '1'
            this.$refs[formType].resetFields()
          }
        }
      })
    },
    onFocus(formType, formProps) {
      this.$refs[formType].clearValidate([formProps])
    },
    onInput(formType, formProps, value) {
      if (isNaN(value)) {
        // this.$message.warning("请输入数字");
        this[formType][formProps] = value.replace(/\D/g, '')
        // this.$refs[formType].clearValidate([formProps]);
      }
    },
    getCurrYear() {
      return new Date().getFullYear()
    },
    isLightTheme() {
      const themeName = this.$theme.get().value
      return themeName === 'stellar-light'
    },
    getLogoBgByTheme() {
      const themeName = this.$theme.get().value
      let thumbnail
      switch (themeName) {
        case 'stellar-light':
          thumbnail = require('@/assets/logo/login_bg_light.png')
          break
        case 'dark':
          thumbnail = require('@/assets/logo/privete_login_bg_dark.webp')
          break
      }
      return thumbnail
    },
    onMouseOver() {
      if (this.indicatorSuccess) return
      if (this.failTimes >= 3) {
        this.imgVisible = true
        if (!this.startTime) {
          this.startTime = new Date().getTime()
        }
        let endTime = new Date().getTime()
        let deltaTime = endTime - this.startTime

        let dictionary = {
          password: ['userName', 'password'],
          message: ['phone', 'validateNo']
        }
        if (
          !Object.keys(this.verificatePictureInfo).length ||
          deltaTime > 5 * 60 * 1000
        ) {
          let params = {
            phone: this.loginForm[dictionary[this.loginType][0]]
          }
          getVerificatePicture(params).then(res => {
            if (res.status === 200) {
              let data = res.data.data
              this.verificatePictureInfo = data
            }
          })
        }
      }
    },
    onMouseLeave() {
      // this.imgVisible = false;
    },
    onMouseDown(e) {
      this.mouseDown = true
      this.mouseDownX = e.clientX
      this.indicatorWidth = this.$refs.indicator.clientWidth
    },
    onMouseMove(e) {
      if (!this.mouseDown || this.indicatorSuccess) return false
      let deltaX = e.clientX - this.mouseDownX
      this.verificatePictureInfo.PositionX = deltaX
      let maxWidth = this.$refs.sliderControl.offsetWidth - 40
      if (deltaX < 0 || deltaX > maxWidth) return
      this.$refs.indicator.style.width = `${
        this.indicatorWidth + deltaX + 40
      }px`
      this.$refs.slider.style.left = `${this.indicatorWidth + deltaX}px`

      this.sliderStatus = 'slider-moving'
      this.indicatorStatus = 'indicator-moving'
      this.tipsText = ''
    },
    onMouseUp() {
      this.mouseDown = false
      if (this.indicatorSuccess) return

      let validateNo = `${this.verificatePictureCode}.${String(
        this.verificatePictureInfo.positionX
      )}`
      let params = {
        userNameOrPhone: this.loginForm.userNameOrPhone,
        password: encryptPassword(this.loginForm.password),
        rememberMe: this.loginForm.rememberMe,
        validateNo: validateNo
      }
      loginService(params).then(response => {
        if (response.status === 200) {
          let data = response.data
          if (data.isSuccess) {
            this.$message.success('滑动验证成功')
            this.indicatorSuccess = true
            this.imgVisible = false
            this.sliderStatus = 'slider-success'
            this.indicatorStatus = 'indicator-success'

            this.verificatePictureCode = String(parseInt(Math.random() * 1000))
          } else {
            this.$message.error(data.errMsg)

            this.indicatorSuccess = false
            this.sliderStatus = 'slider-error'
            this.indicatorStatus = 'indicator-error'
            this.tipsText = '加载中...'

            setTimeout(() => {
              this.sliderStatus = ''
              this.indicatorStatus = ''
              this.$refs.indicator.style.width = '0px'
              this.$refs.slider.style.left = '0px'
              this.tipsText = '向右拖动滑块填充拼图'
            }, 500)

            this.verificatePictureCode = String(parseInt(Math.random() * 1000))
            let params = { code: this.verificatePictureCode }
            getVerificatePicture(params).then(res => {
              if (res.status === 200) {
                let resultData = res.data
                if (resultData.isSuccess) {
                  let verificatePictureInfo = resultData.slideVerificationInfo
                  this.verificatePictureInfo = verificatePictureInfo
                } else {
                  this.$message.error(resultData.errMsg)
                }
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.login-box {
  position: relative;
  height: 100vh;
  user-select: none;

  .home-login {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    background-color: var(--login-bg-color);
    .input-primary {
      :deep(.el-input__inner) {
        background-color: var(--login-panel-input-bgColor);
        border-color: var(--login-panel-input-border-color);
      }
    }
    &-left {
      height: 100%;
      position: relative;

      .logo-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      &-right {
        width: 174px;
        height: 108px;
        position: absolute;
        top: 66%;
        left: 58%;
        transform: scale(0.75);
      }

      &-left {
        width: 148px;
        height: 44px;
        position: absolute;
        top: 32px;
        left: 32px;
      }
    }

    &-right {
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .login-panel {
        width: 456px;
        border-radius: 5px;
        background-color: var(--login-panel-bg-color);
        box-shadow: var(--login-panel-box-shadow);
        border-radius: 16px;
        border: 1px solid var(--login-panel-border-color);
        padding: 36px 50px;
        text-align: left;
        position: absolute;

        .login-title {
          display: flex;
          align-items: center;
          margin-bottom: 28px;
          &-wel {
            margin: auto;
            color: var(--login-panel-title-color);
            font-size: 36px;
          }

          &-tex {
            margin-left: 16px;
            color: var(--login-panel-sub-title-color);
            font-size: 16px;
          }
        }

        .form {
          :deep(.el-form-item) {
            margin-bottom: 24px;
            .el-input__inner {
              border-radius: 8px;
              // background: var(--aside-bg-color);
              // border: 1px solid var(--base-border-dark-color18);
              &:-webkit-autofill,
              &:-webkit-autofill:hover,
              &:-webkit-autofill:focus,
              &:-webkit-autofill:active {
                -webkit-transition-delay: 99999s;
                -webkit-transition: color 99999s ease-out,
                  background-color 99999s ease-out;
              }
            }

            .el-form-item__content {
              .el-form-item__error {
                font-size: 11px;
              }
            }
          }

          .last-form {
            margin-bottom: 28px;
            .login-btn {
              padding-top: 13px;
              padding-bottom: 13px;
              width: 100%;

              :deep(span) {
                display: inline-block;
                font-size: 16px;
                font-weight: 400;
                color: var(--base-light-color25);
              }
            }
          }
        }
      }

      // .footer {
      //   position: absolute;
      //   left: 50%;
      //   transform: translateX(-50%);
      //   bottom: 64px;
      //   white-space: nowrap;
      //   color: var(--copyright-text-color);
      //   font-size: 14px;
      //   font-weight: 400;
      // }
    }
  }

  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #c0c4cc;
  }
}
</style>
